/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React, {
    useState, useCallback, useEffect, useContext, useRef,
} from 'react';
import { Link, useParams } from 'react-router-dom';
import { PriceHandler } from '../../redux/helper/CamelCase';
import { distributorService } from '../../service/distributor.service';
import AddAdjustment from './Modals/addAdjustment';
import FilterModal from './Modals/FilterModal';
import Pagination from '../../Components/Pagination';
import CustomerListSkeleton from '../MISReports/CustomerWiseReport/customerListSkeleton';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import HeaderContext from '../../Components/Context/HeaderContext';
import AdorCashListDetailsSkeleton from './AdorCashDetailsSkeleton';
import { GenerateDate, GenerateDateandTime, GenerateDateFormat } from '../../redux/helper/DateConverter';
import { AccessPrevilegesFunction } from '../../constants/GlobalAccessFunction';

function ViewAdorCashDetails() {
    const adjustcashbackprevilegeassigned = AccessPrevilegesFunction('cashback:adjust');

    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        HardRefresh,
        setHardRefresh,
    } = useContext(HeaderContext);
    const { distributor_id } = useParams();
    const [distributorCashDetails, setdistributorCashDetails] = useState([]);
    const [distributorDetails, setDistributorDetails] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [alldata, setalldata] = useState({});
    const [totalPage, setTotalPage] = useState('');
    const [loading, setLoading] = useState(true);
    const [filterModal, setFilterModal] = useState(false);
    const [emptyData, setEmptyData] = useState(false);
    const [sortType, setsortType] = useState('transaction_date');
    const [filterValue, setfilterValue] = useState('');
    const [freezed, setFreezed] = useState('');
    const [Filter, setFilter] = useState({
        txn_type: [],
    });
    const [addAdjustmentModal, setAddAdjustmentModal] = useState(false);
    const [threedotsLoader, setthreedotsLoader] = useState(false);
    const [adjustmentEntryInformation, setAdjustEntryInformation] = useState({
        distributor_id: '',
        amount: '',
        comment: '',
        type: '',
    });
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [detailsLoader, setDetailsLoader] = useState(true);
    const [hoverId, sethoverId] = useState(false);
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    const handleFetchDistributorDetails = async () => {
        setDetailsLoader(true);
        const data = await distributorService.getDistributorDetail(distributor_id);
        if (data.error === false) {
            setDistributorDetails(data.data.data);
            setDetailsLoader(false);
        } else {
            SetErrorMessage('Something went Error');
            setcolorValue('red');
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue('');
            }, 2000);
        }
    };

    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setLoading(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setLoading(true);
    }, [currentPage, sortType]);

    const handleParticularAdorCashList = useCallback((() => {
        distributorService.ParticularDistributorAdorCashList(distributor_id, currentPage, sortType, debouncedSearch, filterValue).then((response) => {
            if (response.error === false && response.data.data.success_status === true) {
                if (response.data.data.Items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setdistributorCashDetails(response.data.data.Items);
                setFreezed(response.data.data.freezzed);
                setCurrentPage(response.data.data.current_page);
                setTotalPage(response.data.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }), [currentPage, debouncedSearch, sortType, filterValue]);

    const handleExport = useCallback((() => {
        distributorService.ParticularDistributorAdorCashList(distributor_id, currentPage, sortType, debouncedSearch, filterValue, exportSelected).then((val) => {
            if (val.data.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage('Files exported Successfully!');
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    const validate = () => {
        let isvalid = true;
        Object.keys(adjustmentEntryInformation).forEach((value) => {
            switch (value) {
            case 'comment':
            case 'amount':
            case 'type':
                if (adjustmentEntryInformation[value] === '') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: `${value} is required`,
                    }));
                    isvalid = false;
                }
                break;
            default: break;
            }
        });
        return isvalid;
    };

    const handleAdjustment = async () => {
        if (validate()) {
            setthreedotsLoader(true);
            const payload = {
                distributor_id: distributorDetails?.ACCOUNT_NUMBER,
                amount: adjustmentEntryInformation.type === 'DEBIT' ? (parseFloat(adjustmentEntryInformation.amount) * -1) : parseFloat(adjustmentEntryInformation.amount),
                comment: adjustmentEntryInformation.comment,
            };
            const data = await distributorService.AdorCashAdjustment(payload);
            if (data.error === false) {
                setAddAdjustmentModal(false);
                setthreedotsLoader(false);
                handleParticularAdorCashList();
                handleFetchDistributorDetails();
                SetSuccessMessage(data.data.message);
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
                setAdjustEntryInformation((prevState) => ({
                    ...prevState,
                    type: '',
                }));
            } else {
                setAddAdjustmentModal(false);
                setthreedotsLoader(false);
                handleParticularAdorCashList();
                handleFetchDistributorDetails();
                SetSuccessMessage(data.data.message);
                setcolorValue('red');
                setTimeout(() => {
                    SetSuccessMessage('');
                    setcolorValue('');
                }, 2000);
                setAdjustEntryInformation((prevState) => ({
                    ...prevState,
                    type: '',
                }));
            }
        }
    };

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    useEffect(() => {
        handleParticularAdorCashList();
    }, [handleParticularAdorCashList]);

    useEffect(() => {
        handleFetchDistributorDetails();
    }, []);

    return (
        <>
            <div>
                <span className="flex items-center text-xs4 font-normal text-[#090406]">
                    <Link to="/ador-cash-management" className="pr-3.5">
                        <img src="/images/arrow-back-fill.svg" alt="icon" />
                    </Link>
                    Ador Cash Management
                </span>
            </div>
            {detailsLoader ? <AdorCashListDetailsSkeleton /> : (
                <div className="mt-[30px] border border-[#CBC7C7] rounded p-3 bg-[#F5F5FA]">
                    <div className="flex">
                        <div className="w-[60%] border-r border-[#CBC7C7] pr-2">
                            <h5 className="text-xs2 font-semibold text-[#000000]">Distributor/Customer Details</h5>
                            <div className="mt-2.5 flex items-center">
                                <div>
                                    <img src="/images/profile-img.png" alt="icon" loading="lazy" decoding="async" />
                                </div>
                                <div className="pl-4">
                                    <p className="text-base font-semibold text-[#303030]">
                                        {distributorDetails?.FIRST_NAME}
                                        {' '}
                                        {distributorDetails?.LAST_NAME}
                                    </p>
                                    <p className="text-xs13 font-normal text-[#555259]">{distributorDetails?.ACCOUNT_NUMBER}</p>
                                </div>
                            </div>
                            <div className="flex -mx-0.5 mt-2.5 justify-between">
                                <div className="px-0.5">
                                    <p className="text-xs3 font-semibold text-[#808285]">Mobile Number</p>
                                    <p className="pt-1 text-sm font-normal text-[#090406]">{distributorDetails?.PRIMARY_PHONE_NUMBER}</p>
                                </div>
                                <div className="px-0.5">
                                    <p className="text-xs3 font-semibold text-[#808285]">Email Address</p>
                                    <p className="pt-1 text-sm font-normal text-[#090406] break-words">{distributorDetails?.EMAIL_ADDRESS}</p>
                                </div>
                                <div className="px-0.5">
                                    <p className="text-xs3 font-semibold text-[#808285]">Company Name</p>
                                    <p className="pt-1 text-sm font-normal text-[#090406] break-words">{distributorDetails?.PARTY_NAME}</p>
                                </div>
                                <div className="px-0.5 flex items-center self-end pb-1 relative">
                                    <p className="text-xs3 font-semibold text-[#808285]">More Details</p>
                                    <button className="pl-1" data-tooltip-target="moreDetails" data-tooltip-placement="left" data-tooltip-trigger="hover" type="button">
                                        <img
                                            src="/images/info_icon-gray.svg"
                                            alt="icon"
                                            className="cursor-pointer"
                                            onMouseEnter={() => {
                                                setTimeout(() => {
                                                    sethoverId(true);
                                                }, 1000);
                                            }}
                                            onMouseLeave={() => {
                                                setTimeout(() => {
                                                    sethoverId(false);
                                                }, 2000);
                                            }}
                                        />
                                    </button>
                                    {hoverId && (
                                        <div id="moreDetails" role="tooltip" className="inline-block absolute z-[99] px-[18px] pt-3 pb-4 border border-[#CBC7C7] bg-[#F5F5FA] rounded-lg shadow-s2 sm:min-w-[304px] w-[250px]">
                                            <p className="text-xs2 font-bold text-[#000000]">Company Details</p>
                                            <div className="pt-2.5">
                                                <p className="text-xs3 font-semibold text-[#808285]">Mobile Number</p>
                                                <p className="pt-0.5 text-sm font-normal text-[#090406]">{distributorDetails?.SECONDARY_PHONE_NUMBER}</p>
                                            </div>
                                            <div className="pt-3.5">
                                                <p className="text-xs3 font-semibold text-[#808285]">Email Address</p>
                                                <p className="pt-0.5 text-sm font-normal text-[#090406]">{distributorDetails?.EMAIL_ADDRESS}</p>
                                            </div>
                                            <div className="flex -mx-0.5 pt-3.5">
                                                <div className="px-0.5 w-1/2">
                                                    <p className="text-xs3 font-semibold text-[#808285]">GSTIN</p>
                                                    <p className="pt-0.5 text-sm font-normal text-[#090406]">{distributorDetails?.GSTIN}</p>
                                                </div>
                                                <div className="px-0.5 w-1/2">
                                                    <p className="text-xs3 font-semibold text-[#808285]">PAN Number</p>
                                                    <p className="pt-0.5 text-sm font-normal text-[#090406]">{distributorDetails?.PAN_NUMBER}</p>
                                                </div>
                                            </div>
                                            <div className="tooltip-arrow" data-popper-arrow />
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                        <div className="w-[40%] pl-5">
                            <div className="flex -mx-0.5 border-b border-[#CBC7C7] pb-2.5">
                                <div className="w-1/2 px-0.5">
                                    <p className="text-xs6 font-semibold text-[#808285]">Outstanding Amount</p>
                                    <p className="text-xs7 font-normal text-[#090406]">{PriceHandler(distributorDetails?.OUTSTANDING_AMT)}</p>
                                </div>
                                <div className="w-1/2 px-0.5">
                                    <p className="text-xs6 font-semibold text-[#808285]">Overdue Amount</p>
                                    <p className="text-xs7 font-normal text-[#090406]">{distributorDetails?.OVERDUE_AMT ? PriceHandler(distributorDetails?.OVERDUE_AMT) : PriceHandler(0) }</p>
                                </div>
                            </div>
                            <div className="flex -mx-0.5 pb-2.5">
                                <div className="w-1/2 px-0.5">
                                    <p className="text-xs6 font-semibold text-[#808285]">Ador Cash Opening Balance</p>
                                    <p className="text-xs7 font-normal text-[#090406]">{PriceHandler(distributorDetails?.ADOR_CASH_BALANCE)}</p>
                                </div>
                                <div className="w-1/2 px-0.5">
                                    <p className="text-xs6 font-semibold text-[#808285]">Ador Cash Freezed</p>
                                    <p className="text-xs7 font-normal text-[#090406]">{PriceHandler(freezed || 0)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="flex justify-end mt-[18px]">
                <div className="relative">
                    <label htmlFor="search" />
                    <input
                        type="text"
                        name="search"
                        id="search"
                        className="w-[235px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                        placeholder="Search"
                        value={searchValue}
                        onChange={(e) => {
                            setsearchValue(e.target.value);
                        }}
                        autoComplete="off"
                    />
                    <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px]" />
                </div>
                <button
                    type="button"
                    className="h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg ml-3"
                    data-bs-toggle="modal"
                    data-bs-target="#filtermodal"
                    onClick={() => setFilterModal(true)}
                >
                    Filter
                </button>
                <div className="pl-2 dropdown relative">
                    <button
                        type="button"
                        id="exportDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] px-9 border border-[#555259] rounded-lg"
                        onClick={() => setexportClick(!exportClick)}

                    >
                        Export
                    </button>
                    <ul className={`dropdown-menu min-w-[110px] absolute ${exportClick === true ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="exportDropdown">
                        <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                            <a
                                onClick={() => {
                                    setexportSelected('csv');
                                }}
                                className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                href="#"
                            >
                                CSV

                            </a>
                        </li>
                        <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                            <a
                                className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                href="#"
                                onClick={() => setexportSelected('pdf')}
                            >
                                PDF

                            </a>
                        </li>
                        <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                            <a
                                className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                href="#"
                                onClick={() => setexportSelected('excel')}
                            >
                                Excel

                            </a>
                        </li>
                    </ul>
                </div>
                {adjustcashbackprevilegeassigned
                && (
                    <button
                        type="button"
                        className="p-2.5 bg-[#44445E] rounded-lg text-xs2 font-semibold text-[#FFFFFF] ml-2"
                        style={{
                            background: '#44445E',
                            padding: '5px 10px',
                            borderRadius: '4px',
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#addadjustment"
                        onClick={() => setAddAdjustmentModal(true)}
                    >
                        Add Adjustment Entry
                    </button>
                ) }
            </div>
            {loading ? <CustomerListSkeleton /> : (
                <div>
                    {distributorCashDetails.length > 0 && (
                        <div className="overflow-auto dropdown-menu pt-[18px] pb-7 relative" style={{ zIndex: '2' }}>
                            <table className="w-full table-auto relative">
                                <thead>
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                            <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                Transaction Type
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[192px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Ador Cash Txn. Date
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[108px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Type
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[177px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Transaction No.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Transaction Date
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[206px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-end">
                                                Ador Cash Redeemed
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[206px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-end">
                                                Ador Cash Recieved
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[180px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Cash Discount Cal.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[346px] rounded-tr-lg rounded-br-lg">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Comment
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {distributorCashDetails.length > 0 && distributorCashDetails.map((item) => (
                                        <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 bg-[#ffffffe8]">
                                                {item?.transaction_type}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {GenerateDate(item?.created_at)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.type}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.transaction_number}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {GenerateDateandTime(item?.transaction_date)}
                                            </td>
                                            <td className={`text-sm font-normal text-[#090406] py-2.5 px-7 ${item?.amount < 0 ? 'text-end' : 'text-center'}`}>
                                                {item?.amount < 0 ? PriceHandler(item?.amount) : '-'}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                                {item?.amount >= 0 ? PriceHandler(item?.amount) : '-'}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {PriceHandler(item?.ador_cash_calculation)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                                {item?.comment}
                                            </td>
                                        </tr>

                                    ))}

                                </tbody>
                            </table>
                        </div>
                    )}

                    {!loading && distributorCashDetails && distributorCashDetails.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            totalPage={totalPage}
                            List={distributorDetails}
                            currentPage={currentPage}
                        />
                    )}
                    {addAdjustmentModal && (
                        <AddAdjustment
                            addAdjustmentModal={addAdjustmentModal}
                            setAddAdjustmentModal={setAddAdjustmentModal}
                            adjustmentEntryInformation={adjustmentEntryInformation}
                            setAdjustEntryInformation={setAdjustEntryInformation}
                            handleAdjustment={handleAdjustment}
                            threedotsLoader={threedotsLoader}
                            setthreedotsLoader={setthreedotsLoader}
                        />
                    )}
                    {filterModal && (
                        <FilterModal
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                            selected={selected}
                            setselected={setselected}
                            distributorCashDetails={distributorCashDetails}
                            setfilterValue={setfilterValue}
                            filterValue={filterValue}
                            Filter={Filter}
                            setFilter={setFilter}
                            handleParticularAdorCashList={handleParticularAdorCashList}
                            SetSuccessMessage={SetSuccessMessage}
                            handleFilter={handleFilter}
                        />
                    )}

                </div>
            )}
            {emptyData && (
                <EmptyScreen
                    search="yes"
                    text="no Ador cash details"
                    buttonRequired={false}
                    all={debouncedSearch.length > 0 ? 'under searched term' : 'found'}
                />
            )}

        </>
    );
}

export default ViewAdorCashDetails;
